const config = {
  url: process.env.REACT_APP_URL,
  registration_otp: `${process.env.REACT_APP_URL}/send-registration-otp`,
  registration: `${process.env.REACT_APP_URL}/registration`,
  reset_password: `${process.env.REACT_APP_URL}/reset-password`,
  delete: `${process.env.REACT_APP_URL}/delete-my-account`,
  auth: process.env.REACT_APP_AUTH_URL,
  sales: process.env.REACT_APP_SALES_URL,
  real_estate: process.env.REACT_APP_REALESTATE_URL,
  help_desk: process.env.REACT_APP_HELP_DESK_URL,
  ticket: process.env.REACT_APP_TICKET_URL
};
export default config;